import { useState, useEffect } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalf } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import {
  utilGetDocumentFilters,
  utilGetDocumentById,
} from "../../../util/UtilsFirebase";
import { faSearch, faSort } from "@fortawesome/free-solid-svg-icons";

//import "rsuite/dist/rsuite.css";

// style
import "./Resenas.css";

import { Table, Form, Pagination } from "react-bootstrap";

import { DateRangePicker } from "rsuite";

import moment from "moment";

export default function Resenas() {
  // const { user, dispatch, szoneNeg } = useAuthContext()
  // const sFecha = new Date().toLocaleDateString('en-CA').replaceAll('-', '')
  // const { error, document } = useDocument('rate', AppContext.zoneNeg) // + "rgX1hU8XvMenCVQVZO0A_Test Comidas")
  const [data, setData] = useState([]);
  const { register } = useAuthContext();
  const [dataMes, setDataMes] = useState([]);
  const [Meseros, setMeseros] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [userDetailsMes, setUserDetailsMes] = useState({});

  /* Filtros Tablas */

  const [dateRange, setDateRange] = useState([]);

  const handleDateRangeChange = (dateRange) => {
    setDateRange({ dateRange });
  };

  const [dateRangeMes, setDateRangeMes] = useState([]);

  function renderStars(calificacion) {
    const stars = [];
    const roundedRating = Math.round(calificacion);

    for (let i = 1; i <= 5; i++) {
      if (i <= roundedRating) {
        stars.push(<FontAwesomeIcon key={i} icon={faStar} />);
      } else if (i - 0.5 === roundedRating) {
        stars.push(<FontAwesomeIcon key={i} icon={faStarHalf} />);
      } else {
        stars.push(<FontAwesomeIcon key={i} icon={faStarRegular} />);
      }
    }

    return stars;
  }

  const handleDateRangeChangeMes = (dateRangeMes) => {
    setDateRangeMes({ dateRangeMes });
  };

  const [filterText, setFilterText] = useState("");
  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  const filteredData = data.filter((item) => {
    const date = new Date(item.fecha.toDate());
    if (dateRange.dateRange) {
      return (
        (moment(item.fecha.toDate())
          .format("DD/MM/YYYY")
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
          item.resena.toLowerCase().includes(filterText.toLowerCase()) ||
          item.user.toLowerCase().includes(filterText.toLowerCase())) &&
        date >= dateRange.dateRange[0] &&
        date <= dateRange.dateRange[1]
      );
    } else {
      return (
        moment(item.fecha.toDate())
          .format("DD/MM/YYYY")
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.resena.toLowerCase().includes(filterText.toLowerCase()) ||
        item.user.toLowerCase().includes(filterText.toLowerCase())
      );
    }
  });

  const [filterTextMes, setFilterTextMes] = useState("");
  const handleFilterTextChangeMes = (event) => {
    setFilterTextMes(event.target.value);
  };
  const filteredDataMes = dataMes.filter((item) => {
    const date = new Date(item.fecha.toDate());
    if (dateRangeMes.dateRangeMes) {
      return (
        (moment(item.fecha.toDate())
          .format("DD/MM/YYYY")
          .toLowerCase()
          .includes(filterTextMes.toLowerCase()) ||
          item.resena.toLowerCase().includes(filterTextMes.toLowerCase()) ||
          item.user.toLowerCase().includes(filterTextMes.toLowerCase())) &&
        date >= dateRangeMes.dateRangeMes[0] &&
        date <= dateRangeMes.dateRangeMes[1]
      );
    } else {
      return (
        moment(item.fecha.toDate())
          .format("DD/MM/YYYY")
          .toLowerCase()
          .includes(filterTextMes.toLowerCase()) ||
        item.resena.toLowerCase().includes(filterTextMes.toLowerCase()) ||
        item.user.toLowerCase().includes(filterTextMes.toLowerCase())
      );
    }
  });

  /* Ordenar tablas */

  const [sortType, setSortType] = useState("asc");
  //   const sortedData = filteredData.sort(sortData(sortType));
  // function sortData(sortType) {
  //   return function (a, b) {
  //     if (sortType === "asc") {
  //       return moment(a.fecha)
  //         .format("DD/MM/YYYY")
  //         .localeCompare(moment(b.fecha).format("DD/MM/YYYY"));
  //     } else {
  //       return moment(b.fecha)
  //         .format("DD/MM/YYYY")
  //         .localeCompare(moment(a.fecha).format("DD/MM/YYYY"));
  //     }
  //   };
  // }

  const [sortTypeMes, setSortTypeMes] = useState("asc");
  // const sortedDataMes = filteredDataMes.sort(sortDataMes(sortTypeMes));
  // function sortDataMes(sortTypeMes) {
  //   return function (a, b) {
  //     if (sortTypeMes === "asc") {
  //       return moment(a.fecha)
  //         .format("DD/MM/YYYY")
  //         .localeCompare(moment(b.fecha).format("DD/MM/YYYY"));
  //     } else {
  //       return moment(b.fecha)
  //         .format("DD/MM/YYYY")
  //         .localeCompare(moment(a.fecha).format("DD/MM/YYYY"));
  //     }
  //   };
  // }

  /* Paginado Tablas */

  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 7;

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };
  const [currentPageMes, setCurrentPageMes] = useState(1);
  const elementsPerPageMes = 7;
  const getElementsForPageMes = (page) => {
    const startIndex = (page - 1) * elementsPerPageMes;
    const endIndex = startIndex + elementsPerPageMes;
    return filteredDataMes.slice(startIndex, endIndex);
  };

  // const columns = [
  //   // otras columnas
  //   {
  //     Header: "Rating",
  //     accessor: "rating",
  //     Cell: ({ value }) => (
  //       <div className="rating">
  //         {Array.from({ length: value }, (_, i) => (
  //           <span key={i} className="star">
  //             &#9733;
  //           </span>
  //         ))}
  //       </div>
  //     ),
  //   },
  // ];

  useEffect(() => {
    // const localTimeZone = "America/Hermosillo";
    // const currentDate = DateTime.now().setZone(localTimeZone);
    // const startOfDay = currentDate.startOf("day");
    const filtros = [{ campo: "puesto", operador: "==", valor: register.id }];

    const fetchOrders = utilGetDocumentFilters("resena_general", filtros);
    fetchOrders
      .then((fetchedOrders) => {
        setData(fetchedOrders);

        // Fetch user details for each review
        const userPromises = fetchedOrders.map((val) =>
          utilGetDocumentById("users", val.user)
            .then((user) => ({ [val.user]: user })) // Create an object with userId as key and user details as value
            .catch((error) => {
              console.error("Error fetching user data:", error);
              return { [val.user]: null }; // Return null if there's an error fetching user details
            })
        );

        // Wait for all user data promises to resolve
        Promise.all(userPromises).then((userDetailsArray) => {
          // Combine user details into a single object
          const combinedUserDetails = Object.assign({}, ...userDetailsArray);
          setUserDetails(combinedUserDetails);
        });
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });

    const fetchReseñas = utilGetDocumentFilters("resena_mesero", filtros);
    fetchReseñas
      .then((fetchReseñas) => {
        setDataMes(fetchReseñas);
        const userPromises = fetchReseñas.map((val) =>
          utilGetDocumentById("users", val.user)
            .then((user) => ({ [val.user]: user })) // Create an object with userId as key and user details as value
            .catch((error) => {
              console.error("Error fetching user data:", error);
              return { [val.user]: null }; // Return null if there's an error fetching user details
            })
        );

        // Wait for all user data promises to resolve
        Promise.all(userPromises).then((userDetailsArray) => {
          // Combine user details into a single object
          const combinedUserDetails = Object.assign({}, ...userDetailsArray);
          setUserDetailsMes(combinedUserDetails);
        });
        // Fetch user details for each review
        const meserosPromises = fetchReseñas.map((val) =>
          utilGetDocumentById("users", val.mesero)
            .then((user) => ({ [val.mesero]: user })) // Create an object with userId as key and user details as value
            .catch((error) => {
              console.error("Error fetching user data:", error);
              return { [val.mesero]: null }; // Return null if there's an error fetching user details
            })
        );

        // Wait for all user data promises to resolve
        Promise.all(meserosPromises).then((userDetailsArray) => {
          // Combine user details into a single object
          const combinedUserDetails = Object.assign({}, ...userDetailsArray);
          setMeseros(combinedUserDetails);
        });
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, [register.id]);

  return (
    <div>
      <br />
      <h4 className="page-title">RESEÑAS</h4>
      <br />
      <br />
      <div className="container">
        <>
          <Tabs>
            <TabList>
              <Tab>Restaurante</Tab>
              <Tab>Meseros</Tab>
              <Tab>Promedio</Tab>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col-sm-3">
                  <div className="input-group">
                    <Form.Control
                      className="form-control border-end-0 border rounded-pill"
                      type="text"
                      aria-describedby="search-icon"
                      placeholder="Busqueda general"
                      value={filterText}
                      onChange={handleFilterTextChange}
                    />
                    <span className="input-group-append">
                      <button
                        className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                        type="button"
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </span>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="input-group">
                    <DateRangePicker
                      appearance="default"
                      placeholder="Filtar por rango de fechas"
                      onChange={handleDateRangeChange}
                      style={{ width: 230 }}
                    />
                  </div>
                </div>

                <div className="col-lg-12 mrg-tbl">
                  <Table striped bordered hover border="2">
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            setSortType(sortType === "asc" ? "desc" : "asc")
                          }
                        >
                          {" "}
                          <FontAwesomeIcon icon={faSort} /> Fecha
                        </th>
                        <th>Cliente</th>
                        <th>Comentarios</th>
                        <th>Calificación</th>
                        {/* <th
                          onClick={() =>
                            setSortType(sortType === "asc" ? "desc" : "asc")
                          }
                        >
                          {" "}
                          <FontAwesomeIcon icon={faSort} /> Fecha:
                        </th>
                        <th>Reseña:</th>
                        <th>Calificacion:</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {getElementsForPage(currentPage)
                        .sort()
                        .map((val, key) => {
                          return (
                            <tr key={key}>
                              <td>
                                {moment(val.fecha.toDate()).format(
                                  "DD/MM/YYYY"
                                )}
                              </td>
                              <td>
                                {userDetails[val.user]
                                  ? userDetails[val.user].fullName
                                  : "Usuario Desconocido"}
                              </td>
                              <td>
                                {val.resena ? val.resena : "No dejo reseña"}
                              </td>
                              <td>
                                {val.resena_calificacion}{" "}
                                {val.resena_calificacion
                                  ? renderStars(val.resena_calificacion)
                                  : ""}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                  <Pagination>
                    {Array.from({
                      length: Math.ceil(filteredData.length / elementsPerPage),
                    }).map((page, index) => (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPage}
                        className={
                          index + 1 === currentPage ? "btn-paginado" : ""
                        }
                        onClick={() => setCurrentPage(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col-sm-3">
                  <div className="input-group">
                    <Form.Control
                      className="form-control border-end-0 border rounded-pill"
                      type="text"
                      aria-describedby="search-icon"
                      placeholder="Busqueda general"
                      value={filterTextMes}
                      onChange={handleFilterTextChangeMes}
                    />
                    <span className="input-group-append">
                      <button
                        className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                        type="button"
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </span>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="input-group">
                    <DateRangePicker
                      appearance="default"
                      placeholder="Filtar por rango de fechas"
                      onChange={handleDateRangeChangeMes}
                      style={{ width: 230 }}
                    />
                  </div>
                </div>

                <div className="col-lg-12 mrg-tbl">
                  {/*Tabla de Reseñas de Mesero*/}
                  <Table striped bordered hover border="2" id="ex-tblResmesero">
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            setSortTypeMes(
                              sortTypeMes === "asc" ? "desc" : "asc"
                            )
                          }
                        >
                          {" "}
                          <FontAwesomeIcon icon={faSort} /> Fecha:
                        </th>
                        <th>Cliente:</th>
                        <th>Mesero:</th>
                        <th>Reseña:</th>
                        <th>Calificacion:</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getElementsForPageMes(currentPageMes)
                        .sort()
                        .map((val, key) => {
                          return (
                            <tr key={key}>
                              <td>
                                {moment(val.fecha.toDate()).format(
                                  "DD/MM/YYYY"
                                )}
                              </td>
                              <td>
                                {userDetails[val.user]
                                  ? userDetails[val.user].fullName
                                  : "Usuario Desconocido"}
                              </td>
                              <td>
                                {Meseros[val.mesero]
                                  ? Meseros[val.mesero].fullName
                                  : "Usuario Desconocido"}
                              </td>
                              <td>
                                {val.resena ? val.resena : "No dejo reseña"}
                              </td>
                              <td>
                                {val.resena_calificacion}{" "}
                                {val.resena_calificacion
                                  ? renderStars(val.resena_calificacion)
                                  : ""}
                              </td>
                            </tr>
                            // <tr key={key}>
                            //   <td>{moment(val.fecha).format("DD/MM/YYYY")}</td>
                            //   <td title={val.meseroEmail}>{val.mesero}</td>
                            //   <td>{val.resena}</td>
                            //   <td>
                            //     {val.resena_calificacion}{" "}
                            //     {val.resena_calificacion
                            //       ? renderStars(val.resena_calificacion)
                            //       : ""}
                            //   </td>
                            // </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                  <Pagination>
                    {Array.from({
                      length: Math.ceil(
                        filteredDataMes.length / elementsPerPageMes
                      ),
                    }).map((page, index) => (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPageMes}
                        className={
                          index + 1 === currentPageMes ? "btn-paginado" : ""
                        }
                        onClick={() => setCurrentPageMes(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </div>
              </div>
            </TabPanel>
            <TabPanel></TabPanel>
          </Tabs>
        </>
      </div>
    </div>
  );
}
